import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {SelectFilterDataModule} from '../../../../../core/component/select-filter-data/select-filter-data.module';
import {ReportAccountComponentSelectFilterComponent} from './report-account-component-select-filter.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        SelectFilterDataModule,
    ],
    declarations: [
        ReportAccountComponentSelectFilterComponent
    ],
    exports: [
        ReportAccountComponentSelectFilterComponent
    ]
})
export class ReportAccountComponentSelectFilterModule {
}
